import { api } from "api/api";
import { AxiosError } from "axios";
import LoginValidado from "model/login/LoginValidado";
import UsuarioLogin from "model/login/UsuarioLogin";
import FirebaseService from "../../firebase/FirebaseService";
import Conta from "model/administracao/cadastro/Conta";

class LoginService {

    logar(email: string, senha: string) {

        return new Promise<LoginValidado>((resolve, reject): void => {

            FirebaseService.getApp().auth().signInWithEmailAndPassword(email, senha)
                .then(auth => {

                    if (auth.user) {

                        const uid = auth.user.uid;

                        auth.user.getIdToken()
                            .then(token => {

                                api
                                    .post(`/auth`, JSON.stringify(new UsuarioLogin(uid, token)))
                                    .then(response => resolve(response.data))
                                    .catch((err: AxiosError) => reject(err));

                            })
                            .catch((err: AxiosError) => reject(err));
                    } else {
                        // TODO error
                    }

                })
                .catch((err: AxiosError) => reject(err));

            /*api
                .post(`/auth`, JSON.stringify(acao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));*/
        });

    }

    trocarConta(id: number) {
        return new Promise<LoginValidado>((resolve, reject): void => {
            let url = `/auth/trocarConta/${id}`;
            api
                .post(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default LoginService;